import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ArticleViewService} from "@shared/components/article-view/article-view.service";

@Component({
  selector: 'app-article-view',
  templateUrl: './article-view.component.html',
  styles: []
})
export class ArticleViewComponent implements OnInit {
  @Input() visible;//弹框是否可见
  @Input() fkId;//关联id（文章id）
  @Input() fkType;//关联分类（文章：'ARTICLE'）
  @Output() private close = new EventEmitter();
  constructor(private articleViewService:ArticleViewService) { }
  public page:number = 1;
  public count:number = 0;
  public viewList:any = [];
  ngOnInit() {
  }
  //关闭弹窗
  closeModal(){
    this.close.emit();
  }
  //  获取数据
  getViewList(){
    let obj = {
      direction: "DESC",
      fromClientType: "pc",
      number: this.page - 1,
      property: "createdDate",
      size:10,
      rules:[
        {
          field:'fkId',
          values:[this.fkId],
          option:"IN"
        },{
          field:'fkType',
          values:[this.fkType],
          option:"IN"
        }
      ]
    };
    this.articleViewService.getPage(obj).subscribe((data) => {
      this.count = data.totalElements;
      if(data.content){
        this.viewList = data.content;
      }else{
        this.viewList = [];
      }
    })
  }
  ngOnChanges(changes: SimpleChanges){
    if(changes.visible && this.visible){
      this.page = 1;
      this.count = 0;
      this.viewList = [];
      this.getViewList();
    }
  }
}
